export default __webpack_public_path__ + "static/media/hayat-about.f92fb2de.mp4";